














import {Component, Prop, Mixins} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

@Component
export default class BankImg extends Mixins(Assets) {
  @Prop({default: () => ({})}) imgs: Record<string, any>
  @Prop({default: '', type: String}) bankCode: string
  @Prop({default: 30, type: Number}) width: number

  get styles() {
    return {
      height: `${this.width}px`,
    }
  }
}
